import React, { Fragment } from 'react';
import { Dialog, Grid } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import './style.css';

import MyReactFancyBox from "../MyReactFancyBox/MyReactFancyBox";
import "../MyReactFancyBox/fancybox.css";

import TwitterEmbed from "../TwitterEmbed/TwitterEmbed";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <i className="fa fa-close"></i>
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const ProjectSingle = ({ maxWidth, open, onClose, project }) => {
  // Guard: if open is true but no project data, don't render anything.
  if (open && (!project || Object.keys(project).length === 0)) {
    return null;
  }

  // Destructure with default values to prevent errors if fields are missing.
  const {
    button = {},
    leftCard = {},
    rightCard = {},
    bigCoverImage = {},
    mainSection = {},
    customSections = {},
    videos = {},
    moreImages = []
  } = project || {};

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={onClose}
        className="modalWrapper quickview-dialog"
        maxWidth={maxWidth}
      >
        <DialogTitle id="customized-dialog-title" onClose={onClose}/>
        <Grid className="modalBody modal-body project-modal">
          <div className="tp-project-single-area">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-12 col-12">
                  <div className="tp-project-single-wrap">

                    {/* Top Section: Left Card and Right Card */}
                    <div className="tp-project-single-item">
                      <div className="row align-items-center mb-5">
                        {/* Left Card: Title and Description */}
                        <div className="col-lg-7">
                          <div className="tp-project-single-title">
                            <h1>{button.title}</h1>
                          </div>
                          {leftCard.subtitle && <h4>{leftCard.subtitle}</h4>}
                          {leftCard.description && <div style={{ whiteSpace: 'pre-line' }}><p>{leftCard.description}</p></div>}

                        </div>
                        {/* Right Card: Details */}
                        <div className="col-lg-5">
                          <div className="tp-project-single-content-des-right">
                            <ul>
                                {rightCard.client && (
                                    <li>
                                    Client: <span>{rightCard.client}</span>
                                    </li>
                                )}
                                {rightCard.projectType && (
                                    <li>
                                    Project Type: <span>{rightCard.projectType}</span>
                                    </li>
                                )}
                                {rightCard.genre && (
                                    <li>
                                    Genre: <span>{rightCard.genre}</span>
                                    </li>
                                )}
                                {button.techFramework && (
                                    <li>
                                    Tech: <span>{button.techFramework}</span>
                                    </li>
                                )}
                                {rightCard.duration && (
                                    <li>
                                    Duration: <span>{rightCard.duration}</span>
                                    </li>
                                )}
                                {rightCard.completion && (
                                    <li>
                                    Completion: <span>{rightCard.completion}</span>
                                    </li>
                                )}
                                {rightCard.state && (
                                    <li>
                                    State: <span>{rightCard.state}</span>
                                    </li>
                                )}

                                {/* Render the Related Links section if available */}
                                {rightCard.linksSection && rightCard.links && rightCard.links.length > 0 && (
                                    <div>
                                        <h5>{rightCard.linksSection}</h5>

                                        {rightCard.links.map((link, index) => {
                                            return (
                                                <li key={index}>
                                                <a href={link.url} target="_blank" rel="noopener noreferrer">
                                                    {link.text || link.url}
                                                </a>
                                                </li>
                                            );
                                        })}
                                    </div>
                                )}

                            </ul>
                          </div>
                        </div>
                      </div>

                    {/* Big Cover Image */}
                      {bigCoverImage && (
                    <div className="tp-project-single-main-img">
                        <MyReactFancyBox thumbnail={bigCoverImage.thumbnail} image={bigCoverImage.image} caption={bigCoverImage.caption} />
                        </div>
                      )}
                    </div>

                    {/* Main Section */}
                    {(mainSection.title || mainSection.desc || (mainSection.textItems && mainSection.textItems.length > 0)) && (
                        <div className="tp-project-single-item list-widget">
                            {mainSection.title && (
                            <div className="tp-project-single-title">
                                <h3>{mainSection.title}</h3>
                            </div>
                            )}
                            {mainSection.desc && <p>{mainSection.desc}</p>}
                            {mainSection.textItems && mainSection.textItems.length > 0 && (
                            <ul>
                                {mainSection.textItems.map((item, index) => (
                                <li key={index}>{item}</li>
                                ))}
                            </ul>
                            )}
                        </div>
                        )}

                    {/* Custom Sections */}
                    {customSections && customSections.length > 0 && (
                        customSections.map((section, idx) => (
                          <div className="tp-project-single-item list-widget" key={idx}>
                            {section.title && (
                              <div className="tp-project-single-title">
                                <h5>{section.title}</h5>
                              </div>
                            )}
                            {section.desc && <p>{section.desc}</p>}
                            {section.textItems && section.textItems.length > 0 && (
                              <ul>
                                {section.textItems.map((item, index) => (
                                  <li key={index}>{item}</li>
                                ))}
                              </ul>
                            )}
                          </div>
                        ))
                      )}

                    {/* Optional Videos Section */}
                    {videos && videos.length > 0 && videos.map((video, index) => (
                        <div className="tp-project-single-item" key={index}>
                          {video.platform === "twitter" && video.url && (
                            <TwitterEmbed url={video.url} title={video.title} />
                          )}
                          {video.platform === "youtube" && video.url && (
                            <div className="tp-project-single-video-container">
                              <iframe
                                src={video.url}
                                title={video.title || "Project Video"}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                            </div>
                          )}
                        </div>
                    ))}

                    {/* Optional More Images Section */}
                    {moreImages && moreImages.length > 0 && (
                        <div className="tp-project-single-gallery">
                        <div className="tp-project-single-title">
                            <h3>Gallery</h3>
                        </div>
                        <div className="row mt-4">
                            {moreImages.map((imgObj, index) => (
                            <div className="col-md-6 col-sm-6 col-12" key={index}>
                                <div className="tp-p-details-img">
                                <MyReactFancyBox thumbnail={imgObj.thumbnail} image={imgObj.image} caption={imgObj.caption}/>
                                </div>
                            </div>
                            ))}
                        </div>
                        </div>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Dialog>
    </Fragment>
  );
};

export default ProjectSingle;
